import { useQuery } from '@tanstack/react-query';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const FETCH_TICKET_LINK_IMPORT_QUERY_KEY = 'FETCH_TICKET_LINK_IMPORT';

export const useFetchTicketLinkImport = (ticketLinkImportId: string) => {
    return useQuery({
        queryKey: [FETCH_TICKET_LINK_IMPORT_QUERY_KEY, ticketLinkImportId],
        queryFn: () => ticketLinkImportService.getTicketLinkImport(ticketLinkImportId),
    });
};